import React, { useState, memo, useMemo, useCallback } from 'react'
import SbEditable from 'storyblok-react'
import {
  Checkbox as CheckboxUI,
  type CheckboxStyle,
} from '@/components/ui/checkbox'

export type CheckboxBlok = StoryblokComponent & {
  label: string
  style: CheckboxStyle
  marginTop?: number
  marginBottom?: number
}

export interface CheckboxProps {
  blok: CheckboxBlok
}

export const Checkbox = memo(({ blok }: CheckboxProps) => {
  const [checked, setChecked] = useState<boolean>(false)

  const handleChange = useCallback((value: boolean) => {
    setChecked(value)
  }, [])
  const containerStyle = useMemo(
    () => ({
      marginTop: blok.marginTop ? `${blok.marginTop}px` : undefined,
      marginBottom: blok.marginBottom ? `${blok.marginBottom}px` : undefined,
    }),
    [blok.marginTop, blok.marginBottom],
  )

  return (
    <div style={containerStyle}>
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <CheckboxUI
          checked={checked}
          onChange={handleChange}
          style={blok.style}
        >
          {blok.label}
        </CheckboxUI>
      </SbEditable>
    </div>
  )
})

Checkbox.displayName = 'Checkbox Block'
